export class RtcConnectionsManager {
    connections = new Map();
    _peer;
    _mobile;
    constructor() {
        this._mobile = this.isMobileDevice();
    }
    onMessage;
    cacheConnection(myConnectionId, theirConnectionId, conn) {
        return new Promise((resolve) => {
            conn.on("open", () => {
                this.connections.set(theirConnectionId, conn);
                console.debug("RTC: connection open: ", myConnectionId, " and ", theirConnectionId);
                resolve(true);
            });
            conn.on("data", (data) => {
                console.debug("RTC: connection received data: ", data);
                if (this.onMessage) {
                    this.onMessage(data);
                }
            });
            conn.on("error", (err) => {
                console.debug("RTC: connection error: ", err);
            });
        });
    }
    getIceServers(meteredApiKey) {
        return fetch(`https://openchat.metered.live/api/v1/turn/credentials?apiKey=${meteredApiKey}`).then((resp) => resp.json());
    }
    isMobileDevice() {
        return /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(navigator.userAgent);
    }
    getMyConnectionId(userId) {
        const prefix = this._mobile ? "m" : "d";
        return `${prefix}_${userId}`;
    }
    async init(me, meteredApiKey) {
        if (this._peer?.destroyed) {
            this.resetAfterConnectionClosed();
        }
        else if (this._peer) {
            return Promise.resolve(this._peer);
        }
        // peerjs (and its webrtc-adapter dependency) is only loaded once a peer is needed
        const [iceServers, { default: PeerCtor }] = await Promise.all([
            this.getIceServers(meteredApiKey),
            import("peerjs"),
        ]);
        return new Promise((resolve) => {
            const connectionId = this.getMyConnectionId(me);
            this._peer = new PeerCtor(connectionId, {
                // host: "localhost",
                // port: 4000,
                // secure: false,
                config: {
                    iceServers,
                },
            });
            this._peer.on("open", (_id) => {
                if (this._peer) {
                    resolve(this._peer);
                }
            });
            this._peer.on("connection", (conn) => {
                console.debug("RTC: connection received on the peer: ", conn.peer);
                this.cacheConnection(connectionId, conn.peer, conn);
            });
            this._peer.on("disconnected", () => {
                console.debug("RTC: peer lost connection will try to reconnect");
                // reconnect() throws if the peer has already re-established the connection
                // by the time this handler runs
                if (this._peer && !this._peer.destroyed && this._peer.disconnected) {
                    try {
                        this._peer.reconnect();
                    }
                    catch (err) {
                        console.debug("RTC: peer reconnect failed: ", err);
                    }
                }
            });
            this._peer.on("close", () => {
                console.debug("RTC: peer connection closed");
                this.resetAfterConnectionClosed();
            });
            this._peer.on("error", (err) => {
                console.debug("RTC: peer connection error: ", err);
            });
        });
    }
    subscribe(onMessage) {
        this.onMessage = onMessage;
    }
    unsubscribe() {
        this.onMessage = undefined;
    }
    exists(connectionId) {
        return this.connections.has(connectionId);
    }
    create(me, them, meteredApiKey) {
        this.init(me, meteredApiKey).then((peer) => {
            [`m_${them}`, `d_${them}`]
                .filter((c) => !this.exists(c))
                .forEach((c) => {
                this.cacheConnection(peer.id, c, peer.connect(c, { serialization: "json" }));
            });
        });
    }
    disconnectFromUser(them) {
        [`m_${them}`, `d_${them}`].forEach((c) => this.connections.delete(c));
    }
    sendMessage = (userIds, message) => {
        const connectionIds = userIds.flatMap((u) => [`m_${u}`, `d_${u}`]);
        connectionIds.forEach((connectionId) => {
            const conn = this.connections.get(connectionId);
            if (conn && conn.open) {
                try {
                    conn.send(message);
                }
                catch (e) {
                    console.debug("Error sending WebRTC message to " + connectionId, e);
                }
            }
        });
    };
    resetAfterConnectionClosed() {
        this.connections.clear();
        this._peer = undefined;
    }
}
export const rtcConnectionsManager = new RtcConnectionsManager();
